/**
 * Service de cuentas bancarias del solicitante (factoring).
 * Thin wrappers sobre API.*.
 *
 * NOTA: este service expone solo lo que BeforeFacture.vue consume hoy.
 * El listado completo de bancos y la creación/edición se exponen cuando
 * NewMyinfo.vue se migre a la misma capa.
 */

import API from "@/api";

export const listarCuentasEmpresa = (empresaId: number | string) =>
	(API as any).factoring.get_cuentas(empresaId);

export const listarBancos = () =>
	(API as any).getBanks();
